// extracted by css-extract-rspack-plugin
export default {"headline":"recommendation-fragment__Headlines_headline__lb-pN","subHeadline":"recommendation-fragment__Headlines_subHeadline__yz9v-"};